import styled from 'styled-components';

export const Workspace = styled.section`
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    background: var(--color-background, #fff);
`;

export const TabBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 42px;
    padding: var(--space-1, 6px) var(--space-6, 24px);
    border-bottom: 1px solid
        color-mix(
            in srgb,
            var(--micro-app-accent, var(--color-primary)) 10%,
            var(--color-border, #e5e7eb)
        );
    background:
        radial-gradient(
            420px 80px at 50% -40%,
            var(--micro-app-accent-soft, var(--color-muted)),
            transparent 72%
        ),
        linear-gradient(
            180deg,
            color-mix(
                    in srgb,
                    var(--micro-app-accent, var(--color-primary)) 5%,
                    var(--color-background)
                )
                0%,
            var(--color-background) 100%
        );
    gap: var(--space-3, 12px);
`;

export const Content = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    background: color-mix(in srgb, var(--color-muted) 55%, var(--color-background));
`;
